const wishlistModalsKeys = {
  WISHLIST_ITEM_REMOVE_CONFIRM: 'wishlistItemRemoveConfirmModal',
  NOTIFICATION_ON: 'notificationOnModal',
  REMOVE_FROM_WISHLIST: 'removeFromWishlistModal',
  ALL_ITEMS_REMOVED: 'allItemsRemovedModal',
  WISHLIST_NOTIFICATION: 'wishlistNotification',
  COMMON_MODAL: 'commonModal',
};

export default wishlistModalsKeys;
